import React from 'react';
import PropTypes from 'prop-types';
import BaseNext from '../base-next';

const Street = props => {
  const { onChange, value, error, touched, onBlur, id, isDisabled } = props;
  return (
    <BaseNext
      isDisabled={isDisabled}
      data-cv-test="addressStreetLineOne"
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      touched={touched}
      error={error}
      id={id}
      type="text"
      labelText="Address, Line 1 *"
      maxLength={201}
    />
  );
};

Street.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  touched: PropTypes.bool,
  isDisabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string
};

Street.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  value: '',
  touched: false,
  error: false,
  isDisabled: false,
  id: ''
};

export default Street;
